import React from "react";
import logoWebp from "imagens/webp/logo56x56.webp";
import logoPng from "imagens/others/logo56x56.png";

type FreeConsultancyVideoProps = {
  onReleaseButton?: () => void;
};

const FreeConsultancyVideo = ({
  onReleaseButton,
}: FreeConsultancyVideoProps) => {
  const playerContainerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (playerContainerRef.current) {
      playerContainerRef.current.innerHTML = "";

      // Create the custom element
      const smartPlayer = document.createElement("vturb-smartplayer");
      smartPlayer.id = "vid-68950c567db7b1c255c972b7";
      smartPlayer.setAttribute("style", "display: block; margin: 0 auto; width: 100%;");
      playerContainerRef.current.appendChild(smartPlayer);
    }

    // Inject the script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `var s=document.createElement("script"); s.src="https://scripts.converteai.net/d5f7c16d-3536-4b47-9b09-e5896ea2866b/players/68950c567db7b1c255c972b7/v4/player.js", s.async=!0,document.head.appendChild(s);`;
    document.head.appendChild(script);

    // Optional: cleanup script if component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const handlePriorityClick = () => {
    if (onReleaseButton) {
      onReleaseButton();
      return;
    }

    const whatsappUrl =
      "https://wa.me/5517991903768?text=Ol%C3%A1%2C%20me%20inscrevi%20para%20a%20Consultoria%20Gratuita%20e%20gostaria%20de%20furar%20a%20fila";
    if (typeof window !== "undefined") {
      window.open(whatsappUrl, "_blank");
    }
  };

  return (
    <section className="py-6 bg-black text-white">
      <div className="container">
        <div className="flex justify-end mb-4">
          <picture>
            <source srcSet={logoWebp} type="image/webp" />
            <source srcSet={logoWebp} type="image/png" />
            <img
              src={logoPng}
              className="w-8 h-8 mr-4"
              alt='Logo da escola Karden - uma letra "K" branca com uma pequena folha sobre ela'
            />
          </picture>
        </div>
        <h1 className="text-2xl font-bold mb-4 text-green lg:text-center">
          INSCRIÇÃO REALIZADA ✅
        </h1>
        <h2 className="text-xl font-bold mb-6 lg:text-center">
          👇 Temos um rápido recado para você: 👇
        </h2>
        <div className="w-full px-0 xl:px-20 2xl:px-40">
          <div ref={playerContainerRef} />
        </div>
        <div className="mt-6 space-y-4 lg:text-center">
          <p className="text-lg">
            PS: Assista ao recado acima e aguarde o contato de um de nossos
            Especialistas.
          </p>
          <button
            type="button"
            onClick={handlePriorityClick}
            className="w-full sm:w-auto px-6 py-3 text-xl font-black uppercase rounded-lg border-4 border-green text-green transition-colors hover:bg-green hover:text-black"
          >
            👉 QUERO SER ATENDIDO AGORA 👈
          </button>
          <p className="text-base font-semibold underline decoration-2">
            Clique no botão acima caso precise pular a fila 😉
          </p>
        </div>
      </div>
    </section>
  );
};

export default FreeConsultancyVideo;
